import { Flex } from '@chakra-ui/core'
import { CreatorReceiverTimeDisplay } from 'components/Post/PostHeader/CreatorReceiverTimeDisplay'
import { IComment } from 'constants/interfaces'
import { Post } from 'redux/reducers/feed'
import { ChevronLeft } from 'lucide-react'
import { isRtlSelector } from 'redux/selectors/general'
import { useSelector } from 'react-redux'
import React from 'react'

interface Props {
  message: IComment
  chat: Post
  onBack: () => void
}

export const AnnouncementCommentModalHeader = ({ chat, message, onBack }: Props) => {
  const isRtl = useSelector(isRtlSelector)

  return (
    <Flex w="100%" alignItems="center" position="relative" style={{ columnGap: '10px' }}>
      <ChevronLeft
        onClick={onBack}
        cursor="pointer"
        size={20}
        style={{
          transform: isRtl ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
      />
      {chat && (
        <CreatorReceiverTimeDisplay
          created_by={chat?.created_by}
          postOriginUsers={chat?.post_origin_users ?? []}
          users={chat?.users}
          tags={chat?.tags ?? []}
          created_at_ts={message?.updated_at_ts}
          postGroupName={chat?.group_users ?? []}
        />
      )}
    </Flex>
  )
}
